// removed by extract-text-webpack-plugin
module.exports = {"my-loading":"my-loading"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/Loading/style.less
// module id = 665
// module chunks = 431